export default __webpack_public_path__ + "static/google_play_badge_tc-37ec157ba8cf283fba5bf76b4859f623.svg";